export default [
    {
        path: '/r/:code',
        name: 'reference-from-a-friend',
        component: () => import(/* webpackChunkName: "reference-from-a-friend" */ '@/views/ReferenceFromAFriend'),
        props: true,
    },
    {
        path: '/r/:source/:code',
        name: 'reference-from-web',
        component: () => import(/* webpackChunkName: "reference-from-a-friend" */ '@/views/ReferenceFromAFriend'),
        props: true,
    },
];
